import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { TypeHelper } from "src/helpers/TypeHelper";
import { ISalesOrdersDto } from "../dtos/ISalesOrdersDto";
import { ISalesOrderModel } from "../models/ISalesOrderModel";
import { SalesOrdersService } from "src/services/documents/SalesOrdersService";
import { AppEntities } from "src/config/entities";
import { ISalesOrdersProductDto } from "../dtos/ISalesOrdersProductDto";
import { ISalesOrderServiceDto } from "../dtos/ISalesOrderServiceDto";
import { ISalesOrderPaymentOffsetDto } from "../dtos/ISalesOrderPaymentOffsetDto";

interface IProps {
    documentId?: string;
}

export const useFetchSalesOrder = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<ISalesOrdersDto | null>(null);
    const [documentModel, setDocumentModel] = useState<ISalesOrderModel | null>(null);
    const dataService = AppEntities.SalesOrders.getDataService() as SalesOrdersService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: ISalesOrderModel) => {
        if (!documentId) return;
        const requestDto: ISalesOrdersDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: ISalesOrdersDto | null = null;
            let responseProductsDto: ISalesOrdersProductDto[] = [];
            let reponseServicesDto: ISalesOrderServiceDto[] = [];
            let responsePaymentOffsetDto: ISalesOrderPaymentOffsetDto[] = [];
      

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: ISalesOrderModel = {
                ...responseDto,
                products: [...responseProductsDto],
                services:[...reponseServicesDto],
                paymentOffsets:[...responsePaymentOffsetDto]
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}